import{defineMessages}from'react-intl';

export default defineMessages({
label:{
id:'select_store.label',
defaultMessage:'Store Location'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9DcmVhdGVTZWxsaW5nU3VwcG9ydFBhZ2UvU2VsZWN0U3RvcmUvU2VsZWN0U3RvcmUubWVzc2FnZXMuanMiXSwibmFtZXMiOlsiZGVmaW5lTWVzc2FnZXMiLCJsYWJlbCIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLE1BQU87QUFDTEMsR0FBSSxvQkFEQztBQUVMQyxlQUFnQixnQkFGWCxDQURxQixDQUFmLENBQWYiLCJmaWxlIjoiU2VsZWN0U3RvcmUubWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZU1lc3NhZ2VzIH0gZnJvbSAncmVhY3QtaW50bCc7XG5cbmV4cG9ydCBkZWZhdWx0IGRlZmluZU1lc3NhZ2VzKHtcbiAgbGFiZWw6IHtcbiAgICBpZDogJ3NlbGVjdF9zdG9yZS5sYWJlbCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdTdG9yZSBMb2NhdGlvbicsXG4gIH0sXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/pages/CreateSellingSupportPage/SelectStore/SelectStore.messages.js
// module id = 2390
// module chunks = 0